import CommunityGreetingImage from './CommunityGreetingImage.png';
import CommunityGreetingImage2x from './CommunityGreetingImage@2x.png';

interface CommunityGreatingImageProps {
  width?: number;
}

const DEFAULT_ALT_TEXT = 'Сообщество создано! Пригласите первых участников';

export const CommunityGreeting = ({
  width = 260,
}: CommunityGreatingImageProps) => {
  return (
    <img
      alt={DEFAULT_ALT_TEXT}
      src={CommunityGreetingImage}
      srcSet={`${CommunityGreetingImage2x} 2x`}
      width={width}
    />
  );
};
